const getPageBlock = (contentSection: string) => ({
  content_section: contentSection,
});

export default getPageBlock;
